const { prepareBatchParams, toBatchShape } = require('../tools')

// Called by the NHLMIS (PSM) REST API
module.exports = getOrListBatch
async function getOrListBatch (fsApi, queryParams, alias) {
  const {userPrograms, ...restQueryParams} = queryParams
  const aliasOptions = alias !== 'none'
    ? {resolveAlias: {[alias]: true}}
    : {}
  const filters = prepareBatchParams(restQueryParams)
  const res = Object.values(filters).filter(Boolean).length
    ? await fsApi.batch.get(filters, aliasOptions)
      .then((batch) => [batch])
      .catch((_) => {
        // this likely means there is no parent product
        // for the requested batch
        return []
      })
    : await fsApi.batch.list()

  const products = await fsApi.product.listForPrograms(userPrograms)
  const productIds = products.map((p) => p._id)

  const batches = res.filter((b) => productIds.includes(b.productId))

  return batches.map((b) => toBatchShape(b, alias))
}
